import { render } from "./selfregistration.vue?vue&type=template&id=719a8e00&scoped=true"
import script from "./selfregistration.vue?vue&type=script&lang=js"
export * from "./selfregistration.vue?vue&type=script&lang=js"

import "./selfregistration.vue?vue&type=style&index=0&id=719a8e00&scoped=true&lang=css"

import exportComponent from "E:\\lb\\vue30\\tuiguang_meng\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-719a8e00"]])

export default __exports__